import { useState, useEffect } from 'react';
import Timer from '../components/Timer';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';

const mission = {
    time: 40 // 40 minutes
}
export default function Mission3(props) {
    const isMobile = window.innerWidth <= 1024
    const [remainingTime, setremainingTime] = useState(40 * 60); //40 mins
    const [startTime, setStartTime] = useState(new Date());
    const getRemainingTimeString = () => {
        if ((!remainingTime) || remainingTime <= 0) return '00:00'
        let time = remainingTime
        let hours = Math.floor(time / 3600);
        let minutes = Math.floor((time - (hours * 3600)) / 60);
        let seconds = Math.floor(time - (hours * 3600) - (minutes * 60));
        //return `${hours < 10 ? `0` : ''}${hours}:${minutes < 10 ? `0` : ''}${minutes}:${seconds < 10 ? `0` : ''}${seconds}`
        return `${minutes < 10 ? `0` : ''}${minutes}:${seconds < 10 ? `0` : ''}${seconds}`
    }
    useEffect(() => {
        let timeInterval = null
        timeInterval = setInterval(() => {
            let second = (startTime.getTime() + mission.time * 60 * 1000 - Date.now()) / 1000
            setremainingTime(second <= 0 ? 0 : second)
        }
            , 1000)
        return () => { clearInterval(timeInterval) }
    }, [startTime])


    const [question1TabIndex, setQuestion1TabIndex] = useState(0);
    const [question1SelectedAnswers, setQuestion1SelectedAnswers] = useState([]);
    const [question1PopupVisible, setQuestion1PopupVisible] = useState(false);

    const [question2TabIndex, setQuestion2TabIndex] = useState(0);
    const [question2SelectedAnswers, setQuestion2SelectedAnswers] = useState([]);
    const [question2PopupVisible, setQuestion2PopupVisible] = useState(false);

    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[black]' style={{ overflowY: "auto", fontSize: isMobile ? 12 : '1.5rem' }}>
            {/*header*/}
            <div className='w-full flex flex-row justify-between items-center bg-[black]' style={{ gap: isMobile ? '4px' : '16px', overflow: 'auto', paddingLeft: isMobile ? 8 : 24, paddingRight: isMobile ? 8 : 24, height: isMobile ? 50 : 65 }}>
                <Timer text={getRemainingTimeString()} percentage={(1 - ((remainingTime || 0) / ((mission.time * 60) || 1))) * 100} />
            </div>
            {/*end of header*/}

            {/*content*/}
            <div className='flex flex-row w-full flex-1 bg-[#D9D9D9]' style={{ overflow: 'hidden' }}>
                {/*webpages*/}
                <div className='flex flex-col w-full bg-[white]' style={{ border: isMobile ? '2px solid black' : '2px solid black', padding: isMobile ? 4 : 10 }}>

                    <div className='w-full flex flex-row bg-[white] items-center' style={{ border: isMobile ? '2px solid black' : '2px solid black', marginTop: 4, marginBottom: 4, gap: isMobile ? 2 : 6, padding: isMobile ? 2 : 6 }}>
                        <div className='cursor-pointer'>
                            <PreviousSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                        </div>
                        <div className='cursor-pointer'>
                            <NextSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                        </div>
                        <div className='cursor-pointer'>
                            <ReloadSvg height={isMobile ? 18 : 30} width={isMobile ? 18 : 30} />
                        </div>
                        <div className='flex-1'>
                            <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={'https://reading-practice.com'} style={{ fontSize: isMobile ? 10 : 16, height: isMobile ? 26 : 40, paddingLeft: isMobile ? 12 : 24, paddingRight: isMobile ? 12 : 24 }} />
                        </div>
                    </div>
                    {/*end tabs*/}

                    {/*web content*/}
                    <div className='flex w-full flex-1 bg-[white] flex-col justify-start' style={{ overflowY: 'auto', border: '2px solid black' }}>
                        <img src='/閱讀策略/3-01.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略 3-01' />

                        <div className='w-full bg-[#DDF6F2] flex flex-col justify-start p-[32px] items-center'>
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>
                                在線上閱讀的世界裏，我們常常需要像「拼圖」一樣，把散落在同一個網頁、或是不同網頁裏的碎片資訊收集起來，重新組合成一個完整的新觀點。這就是歸納訊息的能力。
                            </div>
                            <br />
                            <img src='/閱讀策略/task3-00.gif' style={{ maxWidth: 'min(100%, 800px)', objectFit: 'contain' }} alt='閱讀策略' />
                            <br />
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>
                                怎麼學？兩步教你做歸納：
                            </div>
                           
                        </div>
                         <img src='/閱讀策略/task3-000.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                        <img src='/閱讀策略/b1.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />

                        <div className='w-full bg-[#E3F2FE] flex flex-col justify-start p-[32px] items-center'>
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>
                                以下是一個介紹海洋生物瀕臨消失的網站，試從內容中找一找，人類哪些行為會對海洋生物造成傷害？
                            </div>
                            <br />
                            <div className='max-w-[1000px] flex flex-col w-full'>
                                {/*tab*/}
                                <div className='flex flex-row w-full justify-start'>
                                    <div className='bg-[#D9D9D9] px-[16px] py-[2px] cursor-pointer' style={{ border: '2px solid black', borderBottom: 'none', borderTopLeftRadius: '4px', borderTopRightRadius: '4px' }}>
                                        網頁一：瀕臨消失的海洋生物
                                    </div>
                                </div>
                                <div className='flex flex-col w-full bg-white items-center'>
                                    <img src='/閱讀策略/3-02.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                                    <br />
                                    <br />
                                    <div className='w-full max-w-[1000px] px-[32px]' style={{ textAlign: 'justify' }}>
                                        海洋學家認為，過度捕魚是人類對海洋最大的傷害。人們喜歡在婚宴等場合吃魚翅。你有沒有想過，人們這種日常生活行為會令每年上億條鯊魚死亡？<mark>商人為了賺錢，大量捕殺鯊魚，把牠們的魚鰭製成魚翅。</mark>為了保護鯊魚，我們不要再吃魚翅了﹗
                                    </div>
                                    <br />
                                    <br />
                                    <img src='/閱讀策略/task3-02.png' style={{ maxWidth: 'min(100%, 600px)', objectFit: 'contain' }} alt='閱讀策略' />
                                    <div className=''>
                                        圖1 把魚鰭製成魚翅
                                    </div>
                                    <br />
                                    <br />
                                    <div className='w-full max-w-[1000px] px-[32px]' style={{ textAlign: 'justify' }}>
                                        珊瑚是一種美麗的海洋生物，色彩艷麗，又稱為「海洋中的熱帶雨林」。近年來，<mark>由於人類把大量有害物質排入大海，破壞了海洋環境，減慢了珊瑚的生長。</mark>此外，隨着全球暖化現象加劇，海水升温，更導致珊瑚出現白化現象，大片大片的珊瑚礁正瀕臨消失。
                                    </div>
                                    <br />
                                    <br />
                                    <img src='/閱讀策略/task3-03.png' style={{ maxWidth: 'min(100%, 600px)', objectFit: 'contain' }} alt='閱讀策略' />
                                    <div className=''>
                                        圖2彩色珊瑚
                                    </div>
                                    <br />
                                    <br />
                                </div>

                            </div>


                            <br />
                            <br />
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>
                                根據「人類哪些行為會對海洋生物造成傷害」的主題，找出關鍵訊息(黃色標示的句字)，把這些訊息拼在一起，完成拼圖。
                            </div>
                            <br />
                            <br />
                            <img src='/閱讀策略/3-03.png' style={{ maxWidth: 'min(100%, 900px)', objectFit: 'contain' }} alt='閱讀策略' />
                            <br />
                            <br />


                        </div>
                        <img src='/閱讀策略/b2.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                        <div className='w-full bg-[#DDFBF6] flex flex-col justify-start p-[32px] items-center'>
                            <br />
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>

                                同學們，學會了「歸納來自相同或不同網頁的訊息」策略後，現在輪到你們試一試！
                                <br />
                                <br />
                                <br />


                                {/*tab*/}
                                <div className='flex flex-row w-full justify-start gap-[16px]'>
                                    <div className={`${question1TabIndex === 0 ? 'bg-[#D9D9D9]' : 'bg-[#888888]'} px-[16px] py-[2px] cursor-pointer`} style={{ border: '2px solid black', borderBottom: 'none', borderTopLeftRadius: '4px', borderTopRightRadius: '4px' }}
                                        onClick={() => setQuestion1TabIndex(0)}
                                    >
                                        網頁一：駱駝散熱真特別
                                    </div>
                                    <div className={`${question1TabIndex === 1 ? 'bg-[#D9D9D9]' : 'bg-[#888888]'} px-[16px] py-[2px] cursor-pointer`} style={{ border: '2px solid black', borderBottom: 'none', borderTopLeftRadius: '4px', borderTopRightRadius: '4px' }}
                                        onClick={() => setQuestion1TabIndex(1)}
                                    >
                                        網頁二：蜥蝪會「跳舞」
                                    </div>
                                </div>
                                {question1TabIndex === 0 &&
                                    <div className='flex flex-col w-full bg-white items-center'>
                                        <img src='/閱讀策略/3-04.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                                        <br />
                                        <br />
                                        <div className='w-full max-w-[1000px] px-[32px]' style={{ textAlign: 'justify' }}>
                                            駱駝是最常見的沙漠動物，背上的駝峰是適合沙漠環境的重要部分。牠的身體保存了大量脂肪，當氣温上升時，脂肪轉變為能量和水，使牠既能生存，也能散熱。
                                        </div>
                                        <br />
                                        <br />
                                        <img src='/閱讀策略/task3-04.png' style={{ maxWidth: 'min(100%, 600px)', objectFit: 'contain' }} alt='閱讀策略' />
                                        <div className=''>
                                            圖1 沙漠動物駱駝
                                        </div>
                                        <br />
                                        <br />
                                        <div className='w-full max-w-[1000px] px-[32px]' style={{ textAlign: 'justify' }}>
                                            另外，長腳讓駱駝的身體主要部分避免了接近炎熱的沙子，腳下厚厚的肉墊也能阻擋熱力。
                                        </div>
                                        <br />
                                        <br />
                                        <img src='/閱讀策略/task3-05.png' style={{ maxWidth: 'min(100%, 600px)', objectFit: 'contain' }} alt='閱讀策略' />
                                        <div className=''>
                                            圖2 駱駝的長腳
                                        </div>
                                        <br />
                                        <br />
                                    </div>
                                }
                                {question1TabIndex === 1 &&
                                    <div className='flex flex-col w-full bg-white items-center'>
                                        <img src='/閱讀策略/3-04.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                                        <br />
                                        <br />
                                        <div className='w-full max-w-[1000px] px-[32px]' style={{ textAlign: 'justify' }}>
                                            動物的吸熱能力有時與顏色有關，顏色越深，吸熱能力越強；顏色越淺，吸熱能力越弱。蜥蜴的散熱方法也是這樣：天熱時，牠們會把身體變成淺色，減少吸熱。
                                            <br /><br />
                                            另外，有些蜥蜴為了減少身體碰到沙地，會用一隻或兩隻腳站立，站累了就換其他腳，好像是在跳舞。
                                        </div>
                                        <br />
                                        <br />
                                        <img src='/閱讀策略/task3-06.png' style={{ maxWidth: 'min(100%, 600px)', objectFit: 'contain' }} alt='閱讀策略' />
                                        <div className=''>
                                            圖3 沙漠動物蜥蝪
                                        </div>
                                        <br />
                                        <br />
                                    </div>
                                }
                            </div>



                            <div className='w-full mt-[16px] flex flex-col items-start gap-[16px] max-w-[600px] bg-[#E3F2FE] p-[16px]'>
                                <div className='w-full'>
                                    1. 以下的散熱方法中，哪幾個是駱駝和蜥蝪這兩種動物都會使用來應對沙漠的熱力的？
                                </div>
                                {[
                                    { text: "A. 把身體顏色變成淺色 ", id: 'A' },
                                    { text: "B. 盡量減少身體接觸炎熱的沙子 ", id: 'B' },
                                    { text: "C. 利用身體的脂肪轉變為水 ", id: 'C' },
                                    { text: "D. 利用身體結構或動作來阻擋沙地熱力 ", id: 'D' },
                                    { text: "E. 留在有冷氣的地方 ", id: 'E' }
                                ].map((option, optionIndex) => (
                                    <div key={optionIndex} className='w-full flex flex-col gap-[4px]'>
                                        <div className='flex flex-row gap-[8px] items-center'>
                                            <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                <button onClick={() => {
                                                    let ans = [...question1SelectedAnswers]
                                                    if (ans.includes(option.id)) {
                                                        ans = ans.filter(a => a !== option.id)
                                                    } else {
                                                        ans.push(option.id)
                                                    }
                                                    setQuestion1SelectedAnswers(ans)
                                                }}
                                                    className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${question1SelectedAnswers.includes(option.id) ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                ></button>
                                            </div>
                                            <div dangerouslySetInnerHTML={{ __html: option.text }}></div>
                                        </div>
                                        <div style={{ borderBottom: '4px dotted #2089dd' }}></div>
                                    </div>
                                ))}
                                <div className='w-full flex flex-row justify-end items-center'>
                                    <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(245,140,0)] px-[12px] py-[4px] rounded-[10px]' onClick={() => {
                                        setQuestion1PopupVisible(true)
                                    }}>
                                        提交
                                    </div>
                                </div>

                            </div>


                        </div>
                        <br />


                        {/*question2*/}
                        <div className='w-full bg-[#F0DDFB] flex flex-col justify-start p-[32px] items-center'>
                            <br />
                            <div className='w-full max-w-[1000px]' style={{ textAlign: 'justify' }}>


                                {/*tab*/}
                                <div className='flex flex-row w-full justify-start gap-[16px]'>
                                    <div className={`${question2TabIndex === 0 ? 'bg-[#D9D9D9]' : 'bg-[#888888]'} px-[16px] py-[2px] cursor-pointer`} style={{ border: '2px solid black', borderBottom: 'none', borderTopLeftRadius: '4px', borderTopRightRadius: '4px' }}
                                        onClick={() => setQuestion2TabIndex(0)}
                                    >
                                        網頁一：獎盃的演變
                                    </div>
                                    <div className={`${question2TabIndex === 1 ? 'bg-[#D9D9D9]' : 'bg-[#888888]'} px-[16px] py-[2px] cursor-pointer`} style={{ border: '2px solid black', borderBottom: 'none', borderTopLeftRadius: '4px', borderTopRightRadius: '4px' }}
                                        onClick={() => setQuestion2TabIndex(1)}
                                    >
                                        網頁二：參賽隊伍的擴展
                                    </div>
                                </div>
                                {question2TabIndex === 0 &&
                                    <div className='flex flex-col w-full bg-white items-center'>
                                        <img src='/閱讀策略/3-06.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                                        <br />
                                        <br />
                                        <div className='w-full max-w-[1000px] px-[32px]' style={{ textAlign: 'center' }}>
                                            世界盃足球賽是全球矚目的體育盛事，你知道它的由來嗎？
                                            <br />
                                            <br />
                                            第一屆世界盃在 1930 年舉行，當時的冠軍獎盃叫「雷米金盃」。這座獎盃經歷過第二次世界大戰，曾被藏在鞋盒裏避開搜查，後來更不幸兩度失竊。直到 1974 年，國際足協設計了全新的「大力神盃」，由兩位運動員張開雙臂捧起地球的造型組成，並規定這座獎盃永遠不會被任何國家永久保留。
                                        </div>
                                        <br />
                                        <br />
                                        <img src='/閱讀策略/task3-07.png' style={{ maxWidth: '300px', objectFit: 'contain' }} alt='閱讀策略' />
                                        <div className=''>
                                            圖1 大力神盃
                                        </div>

                                        <br />
                                        <br />
                                    </div>
                                }
                                {question2TabIndex === 1 &&
                                    <div className='flex flex-col w-full bg-white items-center'>
                                        <img src='/閱讀策略/3-07.png' style={{ width: '100%', objectFit: 'contain' }} alt='閱讀策略' />
                                        <br />
                                        <br />
                                        <div className='w-full max-w-[1000px] px-[32px]' style={{ textAlign: 'center' }}>
                                            四年一度的世界盃，最初只有 13 支隊伍參加，當時許多國家因為交通不便、路途遙遠而無法出席。隨着時代進步，足球運動日漸普及，到了1998年，參賽隊伍增加至 32 隊，讓更多來自不同洲份的國家都有機會登上這個最高舞台。
                                            <br />
                                            <br />
                                            而2026年的世界盃，參賽隊伍已增至48隊，競爭變得越來越激烈。各國為了榮譽全力以赴，目前取得最多冠軍寶座的國家是巴西，他們一共捧走了五次獎盃，被球迷稱為「五星巴西」。
                                            <br />
                                            <br />
                                            從最初只有 13 隊參賽隊伍，到今年擴展至 48 隊，世界盃一步步擴大參與規模，讓世界各地的球迷有更多機會見證頂尖球技與激烈對決。

                                        </div>

                                        <br />
                                        <br />
                                    </div>
                                }
                            </div>

                            <div className='w-full mt-[16px] flex flex-col items-start gap-[16px] max-w-[600px] bg-[#E3F2FE] p-[16px]'>
                                <div className='w-full'>
                                    2.綜合網頁一和網頁二的內容，作者主要想告訴我們甚麼？
                                </div>
                                {[
                                    { text: "A.	世界盃的獎盃曾經歷很多波折 ", id: 'A' },
                                    { text: "B. 世界盃的參賽隊伍一直在減少 ", id: 'B' },
                                    { text: "C. 世界盃是歷史悠久、極受歡迎的體育盛事 ", id: 'C' },
                                    { text: "D. 巴西擁有最多球迷 ", id: 'D' },
                                    { text: "E. 世界盃的獎盃可以由冠軍國家永久保留 ", id: 'E' }
                                ].map((option, optionIndex) => (
                                    <div key={optionIndex} className='w-full flex flex-col gap-[4px]'>
                                        <div className='flex flex-row gap-[8px] items-center'>
                                            <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                <button onClick={() => {
                                                    let ans = [...question2SelectedAnswers]
                                                    if (ans.includes(option.id)) {
                                                        ans = ans.filter(a => a !== option.id)
                                                    } else {
                                                        ans.push(option.id)
                                                    }
                                                    setQuestion2SelectedAnswers(ans)
                                                }}
                                                    className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${question2SelectedAnswers.includes(option.id) ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                ></button>
                                            </div>
                                            <div dangerouslySetInnerHTML={{ __html: option.text }}></div>
                                        </div>
                                        <div style={{ borderBottom: '4px dotted #2089dd' }}></div>
                                    </div>
                                ))}
                                <div className='w-full flex flex-row justify-end items-center'>
                                    <div className='cursor-pointer hover:opacity-[0.8] text-[white] font-bold text-[18px] bg-[rgb(245,140,0)] px-[12px] py-[4px] rounded-[10px]' onClick={() => {
                                        setQuestion2PopupVisible(true)
                                    }}>
                                        提交
                                    </div>
                                </div>

                            </div>


                        </div>
                        <br />




                        {/*return button*/}
                        <button onClick={props.onClose} className='mt-4 px-4 py-2 bg-blue-500 text-white rounded m-[32px]'>返回</button>


                    </div>
                    {/*end of web content*/}




                </div>
                {/*end of webpages*/}






            </div>

            {question1PopupVisible && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
                    <div className='bg-white p-4 rounded max-w-[90%] max-h-[90%] overflow-auto flex flex-col items-center'>
                        <div className='w-full'>答案︰B、D</div>
                        <img src="/閱讀策略/3-05.png" alt="答案示意" className='max-w-[800px]' style={{ objectFit: 'contain' }} />
                        <button onClick={() => setQuestion1PopupVisible(false)} className='mt-4 px-[24px] py-2 text-white rounded-full text-[#0000FF]' style={{border:'2px solid #0000FF'}}>確定</button>
                    </div>
                </div>
            )}
            {question2PopupVisible && (
                <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-80'>
                    <div className='bg-white p-4 rounded max-w-[90%] max-h-[90%] overflow-auto flex flex-col items-center'>
                        <div className='w-full'>答案︰A、C</div>
                        <img src="/閱讀策略/3-08.png" alt="答案示意" className='max-w-[800px]' style={{ objectFit: 'contain' }} />
                        <button onClick={() => setQuestion2PopupVisible(false)} className='mt-4 px-[24px] py-2 text-white rounded-full text-[#0000FF]' style={{border:'2px solid #0000FF'}}>確定</button>
                    </div>
                </div>
            )}




        </div>
    )
}